import React, { Component } from 'react'
import reactCSS from 'reactcss'
import AllOutSharpIcon from '@material-ui/icons/AllOutSharp';
import Slider from '@material-ui/core/Slider';
import { SketchPicker } from 'react-color'
export default class StrokePicker extends Component {
    constructor(props){
        super(props);
        this.state ={
            displayPicker: false,
            align:'left',
            value:props.fTextStroke.trim().split(/\s+/)[0].slice(0, -2),
            color:props.fTextStroke.trim().split(/\s+/)[1]
        }
    }
    handleClick = () => {
        this.setState({ displayPicker: !this.state.displayPicker })
      };
    
      handleClose = () => {
        this.setState({ displayPicker: false })
      };
    
    handleChangeColor = (color) => {
      this.setState({
        color:color.hex
      },()=>{
        this.setData();
      })
    }

    handleChangeStroke =(event, newValue) =>{
      this.setState({
        value:newValue
      },()=>{
        this.setData();
      })
    }

    setData = ()=>{
    let data = {
        stroke:this.state.value,
        stroke_color:this.state.color
    }
    this.props.handleFontStroke(data);
    }

  render() {
    const styles = reactCSS({
        'default': {
          color: {
            width: '30px',
            height: '5px',
            borderRadius: '2px',
          },
          swatch: {
            padding: '1px',
            background: '#fff',
            borderRadius: '1px',
            display: 'inline-block',
            cursor: 'pointer',
            textAlign:'center',
            border:'none',
            position:'relative'
          },
          popover: {
            marginTop:'10px',
            position: 'absolute',
            zIndex: '2',
            backgroundColor:'whitesmoke',
            minWidth:'120px',
            padding:'5px 5px 3px 5px',
            boxShadow:'2px 2px 15px rgb(0 0 0 / 10%)'
          },

          cover: {
            position: 'fixed',
            top: '0px',
            right: '0px',
            bottom: '0px',
            left: '0px',
            zIndex:-1
          },
        },
      });

      return (
        <div>
          <div style={ styles.swatch } onClick={ this.handleClick }>
             <AllOutSharpIcon style={{fontSize:'20px'}}/> <span className='lhValue'>{this.state.value}px</span>
          </div>
          { this.state.displayPicker ? <div style={ styles.popover }>
            <div style={ styles.cover } onClick={ this.handleClose }/>
            <div className='popBox'>
            <label>Stroke</label>
            
            <Slider
             value={this.state.value}
             onChange={this.handleChangeStroke} 
             aria-labelledby="continuous-slider" 
             step={0.5}
             min={0}
             max={10}
             marks
             />
            <br/>
             <label>Stroke Color</label>
             <SketchPicker color={ this.state.color } onChange={ this.handleChangeColor } />
            </div>
          </div> : null }
  
        </div>
      )
    }
  
}
